import { API } from "../../../axios";
import swal from "sweetalert2";
import { handleRegistrationError } from "@/plugins/store/errorHandlerSwal";
import { setTokens, clearTokens } from "@/plugins/authTokens";

const actions = {

  login({ dispatch, commit }, club) {

    return new Promise((resolve, reject) => {
      commit("auth_request");
      API.post("club/login", club)
        .then(resp => {

          const token = resp.data.access_token;
          const club = resp.data.club;
          const clubmenu = resp.data.clubmenu;
          const club_qrcode = resp.data.qrcode;

          localStorage.setItem("token", token);
          // Bei QR-Code/Link-Login liefert das Backend keinen Refresh-Token (null)
          setTokens("club", token, resp.data.refresh_token);
          API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
          commit("auth_success", { club, token, clubmenu, club_qrcode });

          // Login ist fertig → User kann navigieren
          resolve(resp);

          dispatch("loadClubData");
        })
        .catch(err => {
          // console.log(err)
          commit("auth_error");
          // Bei 500 o. Ä. ist data ein Objekt – SweetAlert braucht Text
          const data = err.response && err.response.data;
          const message = typeof data === "string" ? data : (data && data.message) || "Anmeldung fehlgeschlagen.";
          swal.fire("Anmeldung!", message, "warning");
          localStorage.removeItem("token");
          clearTokens("club");
          reject(err);
        });
    });
  },

  // Daten, die nach dem Login gebraucht werden. Läuft auch bei jedem App-Start
  // (index.vue), weil die Listen nicht mehr im localStorage liegen.
  async loadClubData({ dispatch }) {
    try {
      await Promise.all([
        dispatch("ClubApp/getVwelcomeText", null, { root: true }),
        dispatch("ClubApp/getWeapons", null, { root: true })
      ]);
    } catch (err) {
      console.error("Error loading critical data:", err);
    }
  },

  logout({ commit, state, rootState }) {
    return new Promise((resolve, reject) => {
      API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
      API.post("club/logout",
        {
          id: state.club.id
        })
        .then(() => {

          commit("logout");
          commit("ClubApp/set_appDataClear", null, { root: true });
          localStorage.removeItem("token");
          clearTokens("club");
          delete API.defaults.headers.common["Authorization"];
          resolve();
        })
        .catch(err => {
          // console.log(err)
          commit("auth_error", err);
          localStorage.removeItem("token");
          clearTokens("club");
          reject(err);
        });

    });
  },
  async setClubProfilData({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/profil/update", Data)
      .then(() => {
        dispatch("getClubProfilData");
      })
      .catch(error => {
        handleRegistrationError(error);
      });

  },

  async setNewPassword({ dispatch, rootState }, Data) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/profil/changePassword", Data)
      .then(() => {
        dispatch("getClubProfilData");
        swal.fire("Passwort geändert", "Dein Passwort wurde geändert", "info");
      })
      .catch(error => {
        handleRegistrationError(error);
      });

  },
  async getClubProfilData({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.get("/club/profil")
      .then((resp) => {
        const club = resp.data.club;
        commit("SET_PROFIL_DATA", { club });
      })
      .catch(error => {
        console.log(error);
      });
  },

  // Fehler bewusst weiterreichen: register.vue zeigt sie am Feld an und bleibt auf der Seite
  async registerClub(_, Data) {
    const resp = await API.post("/club/register", Data);
    return resp.data;
  },

  async generateQrCode({ commit, rootState }) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.get("/club/profil/QrCode/generate")
      .then((resp) => {
        console.log(resp);
        const club = resp.data;
        commit("SET_CLUB_QRCODE", club);
      })
      .catch(error => {
        console.log(error);
      });
  },

  async setAutoBestaetigungHolen({ commit, rootState }, enabled) {
    API.defaults.headers.common["Authorization"] = `Bearer ${rootState.ClubAuth.Clubtoken}`;
    await API.post("/club/profil/auto-bestaetigung-holen", { enabled })
      .then((resp) => {
        commit("SET_AUTO_BESTAETIGUNG_HOLEN", resp.data.auto_bestaetigung_holen);
      })
      .catch(error => {
        handleRegistrationError(error);
      });
  }


};

export default actions;
